import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";
import { useEffect, useState } from 'react';

const EditItemModal = ({ tabData,show, onClose, itemDataReal, onChange, full_Item_Detail, fulldata }) => {
  const { data: current_item } = useGetDoctypeDetailsQuery({ "doctype": "Item", "name": itemDataReal?.item_code });
  const [itemData, setitemData] = useState({});
   console.log("itemDataRealitemDataRealitemDataRealitemDataReal",itemDataReal);
   console.log("itemDataRealitemDataRealitemDataRealitemDataReal 2222",fulldata);


  useEffect(()=>{
   
    setitemData(itemDataReal);

  },[itemDataReal])




    const downloadCSV = () => {
    const serials = itemDataReal.Sno || [];
    if (serials.length === 0) return;

    const csvContent = "data:text/csv;charset=utf-8," + serials.map((s, i) => `${i + 1},${s}`).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `serial_numbers_${itemDataReal?.item_code || "item"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  if (!show || !itemData) return null;

  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...itemData, [name]: value });
  };



  const handleRemoveSerial = (serial) => {
    onChange(serial);
  };



  console.log("full_Item_Detailfull_Item_Detailfull_Item_Detailfull_Item_Detail",full_Item_Detail,itemDataReal);

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Item</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-6">
                <div className="mb-2">
                  <label style={{ fontSize: '0.8rem' }}>Sales Order No.</label>
                  <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="accepted_qty" value={full_Item_Detail.sales_order} />
                </div>
              </div>
              <div className="col-6">
                <div className="mb-2">
                  <label style={{ fontSize: '0.8rem' }}>Customer</label>
                  <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="rejected_qty" value={fulldata?.message?.customer} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="mb-2">
                  <label style={{ fontSize: '0.8rem' }}>Item Name</label>
                  <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="accepted_qty" value={full_Item_Detail.item_name} />
                </div>
              </div>
              <div className="col-6">
                <div className="mb-2">
                  <label style={{ fontSize: '0.8rem' }}>Item Code</label>
                  <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="rejected_qty" value={full_Item_Detail.item_code} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="mb-2">
                  <label style={{ fontSize: '0.8rem' }}>Quantity</label>
                  <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="qty" value={full_Item_Detail.qty} />
                </div>
              </div>
        
              <div className="col-6">
                <div className="mb-2">
                  <label style={{ fontSize: '0.8rem' }}>UOM</label>
                  <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" readOnly name="accepted_qty" value={full_Item_Detail.uom} />
                </div>
              </div>
            </div>

            <div className="row">
             {/* <div className="col-6">
                <div className="mb-2">
                  <label style={{ fontSize: '0.8rem' }}>Total Qty</label>
                  <input className="form-control" style={{ fontSize: '0.8rem' }} type="text" name="rejected_qty" readOnly value={full_Item_Detail.qty} />
                </div>
              </div> */}
               {/* <div className="col-6">
                  <div className="mb-2">
                    <label style={{ fontSize: '0.8rem' }}>Expiry Date</label>
                    <input
                      className="form-control"
                      style={{ fontSize: '0.8rem' }}
                      type="text"
                      name="expiry_date"
                    
                    />
                  </div>
                </div>
           */}
            </div>


    {current_item?.message?.has_serial_no == 1 && (
  <div className="row">
    <div className="col-6">



         {current_item?.message?.has_serial_no == 1 && (
   
              
                  <div className="mb-1">
                    <label style={{ fontSize: '0.8rem' }}>Batch No.</label>
                    <div className="d-flex flex-column mb-2">
                    <input
                      className="form-control"
                      style={{ fontSize: '0.8rem' }}
                      type="text"
                      readOnly
                      name="batch_no"
                      value={itemData.batch_no || ""}
                      onChange={handleInput}
                    />
                    </div>
                  </div>
             
  
            )}

     
    </div>
    <div className="col-6">
        <label style={{ fontSize: '0.8rem' }}>Scanned Serial Numbers</label>

      <div 
          className="serial-list-container p-1 bg-light rounded" 
          style={{ 
            border: '1px solid #ddd',
            height: '150px', 
            overflowY: 'auto', 
            backgroundColor: '#f8f9fa' 
          }}
        >
          {itemData.Scanned_Sno?.length > 0 ? (
            <table className="table table-sm mb-0">
              <tbody>     
              
                {itemData.Scanned_Sno?.map((serial, index) => (
                  <tr key={index}>
                    <td width="30" style={{ fontSize: '0.8rem' }}>{index + 1}.</td>
                    <td style={{ fontSize: '0.8rem',textAlign:'start' }}>{serial}</td>
                    <td width="30" className="text-end">
                      <button
                        onClick={() => handleRemoveSerial(serial,index)}
                        className="btn btn-sm p-0 px-1"
                        title="Remove serial"
                        style={{ lineHeight: '1',border:'0px',color:'red', }}
                      >
                        ×
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div 
              className="text-muted d-flex align-items-center justify-content-center h-100" 
              style={{ fontSize: '0.8rem' }}
            >
              No serial numbers scanned yet
            </div>
          )}
        </div>
                  <div className="d-flex justify-content-between align-items-center">

        <div className="mt-1 text-end" style={{ fontSize: '0.75rem' }}>
          Total: {itemData?.Scanned_Sno?.length || 0} serial numbers
        </div>
        {itemData?.Sno?.length > 0 && (
                      <button className="custom-btn-00989 mt-1" onClick={downloadCSV} style={{ fontSize: '0.75rem' }}>
                        Download CSV
                      </button>
                    )}
                    </div>
    </div>
  </div>
)}

{console.log("full_Item_Detailfull_Item_Detailasdfgfd",itemData)}
          </div>
      
        </div>
      </div>
    </div>
  );
};

export default EditItemModal;